import { ChangeEvent } from 'react'

interface Props {
  labelText: React.ReactElement<'p'>
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void
  checked?: boolean
  disabled?: boolean
}

const Switch = ({ labelText, checked = false, disabled = false, handleChange }: Props) => (
  <label className="relative inline-flex cursor-pointer items-center gap-1">
    <input
      onChange={handleChange}
      type="checkbox"
      value=""
      className="peer sr-only"
      checked={checked}
      disabled={disabled}
    />
    <div className="peer h-3 w-6 rounded-full bg-gray-200 after:absolute after:left-0.5 after:top-[2px] after:size-[20px] after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-[''] peer-checked:bg-surface-brand-primary peer-checked:after:translate-x-full peer-checked:after:border-white peer-focus:outline-none peer-focus:ring-2 peer-disabled:opacity-50 dark:border-gray-600 dark:bg-gray-700" />
    {labelText}
  </label>
)

export default Switch
